import CustomButton from "../../../../components/CustomButton/Button";
import { formatDateTime } from "../../../../helpers/helpers";
import { safeIdSort, safeStringSort } from "../../../../helpers/sortHelpers";
import {
  BTN_TXT,
  GLOBAL_CONSTANTS,
  ROLE_STYLES,
} from "../../../../constants/constants";
import { Tag } from "antd";

export const getRmDetailColumns = ({ onReassign } = {}) => [
  {
    title: "Customer ID",
    dataIndex: "userId",
    key: "userId",
    width: 180,
    sorter: (a, b) => safeIdSort(a?.userId, b?.userId),
  },
  {
    title: "Customer Name",
    dataIndex: "userName",
    key: "userName",
    width: 250,
    sorter: (a, b) => safeStringSort(a?.userName, b?.userName),
  },
  {
    title: "Organization",
    dataIndex: "orgName",
    key: "orgName",
    width: 300,
    sorter: (a, b) => safeStringSort(a?.orgName, b?.orgName),
  },
  {
    title: "Role",
    dataIndex: "roleName",
    key: "roleName",
    render: (role) => <Tag style={ROLE_STYLES[role]}>{role}</Tag>,
  },
  {
    title: "Status",
    dataIndex: "userStatusName",
    key: "userStatusName",
    width: 150,
  },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 200,
    render: (value) => (value ? formatDateTime(value) : GLOBAL_CONSTANTS.NA),
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    render: (_, record) => {
      return (
        <CustomButton
          type="primary"
          onClick={() => onReassign?.(record)}
        >
          {BTN_TXT.RE_ASSIGN_RM}
        </CustomButton>
      );
    },
  },
];
